import React, { useEffect, useState } from 'react'
import { ReCAPTCHA } from 'react-google-recaptcha'
import { port } from '../App'
import axios from 'axios'
import { toast } from 'react-toastify'
import { motion } from 'framer-motion'
import { Send, MapPin, Phone, Mail } from 'lucide-react'

const ContactForm = () => {
    let [errorMessage, setErrormessage] = useState('')
    const [contactForm, setContactForm] = useState({
        email: '',
        message: '',
        first_name: '',
        last_name: '',
        phone: '',
        captcha: false
    })
    let [loading, setloading] = useState('')
    
    let handlechange = (e) => {
        let { name, value } = e.target
        if (name == 'phone' && value.length > 10)
            value = contactForm.phone
        setContactForm((prev) => ({
            ...prev,
            [name]: value
        }))
    }
    
    let validateForm = () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emailRegex.test(contactForm.email) && contactForm.phone != '' && contactForm.first_name != '' && contactForm.message != '') {
            setErrormessage('')
            return true
        }
        else if (!emailRegex.test(contactForm.email) && contactForm.phone == '' && contactForm.first_name == '' && contactForm.message == '') {
            setErrormessage('*Enter all the required inputs')
        }
        else if (!emailRegex.test(contactForm.email)) {
            setErrormessage("Enter the proper mail and other inputs")
        }
        else {
            setErrormessage('*Enter all the required inputs')
        }
    }
    
    let postContact = (e) => {
        e.preventDefault()
        if (contactForm.captcha) {
            if (validateForm()) {
                setloading('contact')
                axios.post(`${port}/blog/ContactsInformation/`, contactForm).then((response) => {
                    console.log(response.data);
                    toast.success('Your Message has been sent. Our team will get in touch shortly.')
                    setloading('')
                    setContactForm({
                        email: '',
                        message: '',
                        first_name: '',
                        last_name: '',
                        phone: '',
                        captcha: false
                    })
                }).catch((error) => {
                    console.log(error);
                    setloading('')
                })
            }
        }
        else {
            setErrormessage('*Please verify the Captcha')
        }
    }

    return (
        <div className="container mx-auto px-6">
            <div className="max-w-6xl mx-auto flex flex-col lg:flex-row gap-8">
                
                {/* Left: Contact Information Cards */}
                <div className="lg:w-1/3 space-y-6">
                    <motion.div 
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        className="bg-white p-8 rounded-3xl shadow-xl shadow-blue-900/5 border border-slate-100 flex flex-col items-start gap-4"
                    >
                        <div className="p-4 bg-blue-50 text-blue-600 rounded-2xl">
                            <MapPin size={24} />
                        </div>
                        <div>
                            <h3 className="font-bold text-slate-900 text-lg mb-2">Office Address</h3>
                            <p className="text-slate-500 text-sm leading-relaxed">
                                1st Floor, 334/28, 14th Cross Rd, 2nd Block, Jayanagar, Bengaluru, Karnataka 560011
                            </p>
                        </div>
                    </motion.div>

                    <motion.div 
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.1 }}
                        className="bg-white p-8 rounded-3xl shadow-xl shadow-blue-900/5 border border-slate-100 flex flex-col items-start gap-4"
                    >
                        <div className="p-4 bg-emerald-50 text-emerald-600 rounded-2xl">
                            <Phone size={24} />
                        </div>
                        <div>
                            <h3 className="font-bold text-slate-900 text-lg mb-2">Phone Numbers</h3>
                            <p className="text-slate-500 text-sm mb-1">+91 89045 99282</p>
                            <p className="text-slate-500 text-sm">+91 98765 43212</p>
                        </div>
                    </motion.div>

                    <motion.div 
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.2 }}
                        className="bg-white p-8 rounded-3xl shadow-xl shadow-blue-900/5 border border-slate-100 flex flex-col items-start gap-4"
                    >
                        <div className="p-4 bg-purple-50 text-purple-600 rounded-2xl">
                            <Mail size={24} />
                        </div>
                        <div>
                            <h3 className="font-bold text-slate-900 text-lg mb-2">Email Address</h3>
                            <a href="mailto:info@meridahr.com" className="text-slate-500 text-sm hover:text-blue-600 transition-colors">
                                info@meridahr.com
                            </a>
                        </div>
                    </motion.div>
                </div>

                {/* Right: Modern Glassmorphism Form */}
                <motion.div 
                    initial={{ opacity: 0, scale: 0.98 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    className="lg:w-2/3 bg-white/80 backdrop-blur-xl border border-white p-8 md:p-12 rounded-[2.5rem] shadow-2xl shadow-blue-900/10"
                >
                    <h2 className="text-2xl font-bold text-slate-900 mb-2 syne">Send us a message</h2>
                    <p className="text-slate-500 text-sm mb-8">We usually respond within 24 hours.</p>

                    <form className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-8" onSubmit={postContact}>
                        {/* Name Input */}
                        <div className="relative group">
                            <input 
                                type="text" 
                                name="first_name"
                                value={contactForm.first_name}
                                onChange={handlechange}
                                className="w-full bg-transparent border-b-2 border-slate-200 py-3 outline-none focus:border-blue-600 transition-colors peer text-slate-800"
                                placeholder=" "
                            />
                            <label className="absolute left-0 top-3 text-slate-400 font-medium pointer-events-none transition-all peer-focus:-top-4 peer-focus:text-blue-600 peer-focus:text-xs peer-[:not(:placeholder-shown)]:-top-4 peer-[:not(:placeholder-shown)]:text-xs">
                                Full Name
                            </label>
                        </div>

                        {/* Phone Input */}
                        <div className="relative group">
                            <input 
                                type="number" 
                                name="phone"
                                value={contactForm.phone}
                                onChange={handlechange}
                                className="w-full bg-transparent border-b-2 border-slate-200 py-3 outline-none focus:border-blue-600 transition-colors peer text-slate-800"
                                placeholder=" "
                            />
                            <label className="absolute left-0 top-3 text-slate-400 font-medium pointer-events-none transition-all peer-focus:-top-4 peer-focus:text-blue-600 peer-focus:text-xs peer-[:not(:placeholder-shown)]:-top-4 peer-[:not(:placeholder-shown)]:text-xs">
                                Phone Number
                            </label>
                        </div>

                        {/* Email Input */}
                        <div className="relative group md:col-span-2">
                            <input 
                                type="email" 
                                name="email"
                                value={contactForm.email}
                                onChange={handlechange}
                                className="w-full bg-transparent border-b-2 border-slate-200 py-3 outline-none focus:border-blue-600 transition-colors peer text-slate-800"
                                placeholder=" "
                            />
                            <label className="absolute left-0 top-3 text-slate-400 font-medium pointer-events-none transition-all peer-focus:-top-4 peer-focus:text-blue-600 peer-focus:text-xs peer-[:not(:placeholder-shown)]:-top-4 peer-[:not(:placeholder-shown)]:text-xs">
                                Email Address
                            </label>
                        </div>

                        {/* Message Input */}
                        <div className="relative group md:col-span-2">
                            <textarea 
                                name="message"
                                value={contactForm.message}
                                onChange={handlechange}
                                rows={4}
                                className="w-full bg-transparent border-b-2 border-slate-200 py-3 outline-none focus:border-blue-600 transition-colors peer text-slate-800 resize-none"
                                placeholder=" "
                            />
                            <label className="absolute left-0 top-3 text-slate-400 font-medium pointer-events-none transition-all peer-focus:-top-4 peer-focus:text-blue-600 peer-focus:text-xs peer-[:not(:placeholder-shown)]:-top-4 peer-[:not(:placeholder-shown)]:text-xs">
                                How can we help you?
                            </label>
                        </div>

                        {errorMessage && (
                            <div className="md:col-span-2">
                                <p className="text-red-500 text-sm font-medium">{errorMessage}</p>
                            </div>
                        )}

                        {/* ReCAPTCHA */}
                        <div className="md:col-span-2 flex justify-start items-center">
                            <ReCAPTCHA
                                sitekey="6LeYRF0qAAAAACTDwiTBcsyIbtbZCl59hcFHWCdI"
                                onChange={() => {
                                    setContactForm((prev) => ({
                                        ...prev,
                                        captcha: !contactForm.captcha
                                    }))
                                }}
                            />
                        </div>

                        {/* Submit Button */}
                        <div className="md:col-span-2 mt-4">
                            <motion.button 
                                type="submit"
                                whileHover={{ scale: 1.02 }}
                                whileTap={{ scale: 0.98 }}
                                disabled={loading === 'contact'}
                                className="w-full bg-blue-600 text-white px-10 py-4 rounded-2xl font-bold flex justify-center items-center gap-3 shadow-xl shadow-blue-600/20 hover:bg-blue-700 transition-all disabled:opacity-70 disabled:cursor-not-allowed"
                            >
                                {loading === 'contact' ? 'Sending...' : 'Send Message'}
                                <Send size={18} className={loading === 'contact' ? 'animate-pulse' : ''} />
                            </motion.button>
                        </div>
                    </form>
                </motion.div>
            </div>
        </div>
    )
}

export default ContactForm